module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/prong-light-bgimage.83bf2b2d.svg";